import { useCallback, useEffect } from "react";
import { isAuthenticated } from "../services/Auth";
import { apiNiches } from "../services";
import { useFetch } from "./useFetch";

interface IFetchFollowingNichesProps {
  previews: boolean;
  tags?: string[];
  preference?: string;
}

export const useFollowingNichesQuery = (props: IFetchFollowingNichesProps) => {
  const fetchFollowingNiches = useCallback(() => apiNiches.getFollowingNiches(props), []);
  const { data, isLoading, error, execute } = useFetch(fetchFollowingNiches, false);

  useEffect(() => {
    (async () => {
      try {
        if (await isAuthenticated()) {
          execute();
        }
      } catch (err) {
        console.error("Error checking authentication:", err);
      }
    })();
  }, [execute]);

  return {
    niches: data ? data.niches : [],
    isLoading,
    error,
  };
};
